"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _DropdownMenuItem = _interopRequireDefault(require("./DropdownMenuItem"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownMenu = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var id = _ref.id,
      dropdownTriggerId = _ref.dropdownTriggerId,
      iconsPosition = _ref.iconsPosition,
      visualFocusIndex = _ref.visualFocusIndex,
      menuItemOnClick = _ref.menuItemOnClick,
      onKeyDown = _ref.onKeyDown,
      options = _ref.options,
      styles = _ref.styles;
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.dropdown
  }, /*#__PURE__*/_react["default"].createElement(DropdownMenuContainer, {
    onMouseDown: function onMouseDown(event) {
      // Prevent the onBlur event from closing menu when clicking on the menu since it is implemented with a Portal and the menu is not a child of the container
      event.preventDefault();
    },
    onKeyDown: onKeyDown,
    id: id,
    role: "menu",
    "aria-labelledby": dropdownTriggerId,
    "aria-orientation": "vertical",
    "aria-activedescendant": "option-".concat(visualFocusIndex),
    tabIndex: -1,
    style: styles,
    ref: ref
  }, options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(_DropdownMenuItem["default"], {
      id: "option-".concat(index),
      key: "option-".concat(index),
      visuallyFocused: index === visualFocusIndex,
      iconPosition: iconsPosition,
      onClick: menuItemOnClick,
      option: option
    });
  })));
});

var DropdownMenuContainer = _styledComponents["default"].ul(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  max-height: 230px;\n  overflow-y: auto;\n  padding: 0;\n  margin: 0;\n  background-color: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  outline: none;\n"])), function (props) {
  return props.theme.optionBackgroundColor;
}, function (props) {
  return props.theme.borderThickness;
}, function (props) {
  return props.theme.borderStyle;
}, function (props) {
  return props.theme.borderColor;
}, function (props) {
  return props.theme.borderRadius;
});

var _default = /*#__PURE__*/_react["default"].memo(DropdownMenu);

exports["default"] = _default;